import React from "react";
import SVGraphics from "../../../assets/SVGraphics";
import utils from "../../../utils/utils";
import BodySeparator from "../../../components/customComp/BodySeparator";
import PatientCaseList from './PatientCaseList'
import BodyHeader from "../../../components/customComp/BodyHeader";
const PatientBody = (props) => {
  const {
    patientCases,
    addTab
  } = props;
  console.log(addTab);
  
  return (
    <div className={"flex-col flex w-full h-full max-h-[90%] overflow-hidden"}>
      <h2 className='text-white text-[20px] mb-[15px]'>Cases</h2>
      <div className="listLabels text-white font-Inter opacity-50 text-[13px] font-normal flex">
        <div className="ml-[30px] w-caseId">Case Number</div>
        <div className="w-risNumber">RIS Number</div>
        <div className="w-aquisitionDateHx">Aquisition Date</div>
        <div className="w-status">Status</div>
        <div className="w-findings">Findings</div>
      </div>
      {/* <BodySeparator text={`Findings (${patientCount})`} marginBottom="22px"/> */}
   
      <PatientCaseList patientCases={patientCases} addTab={addTab}/>
    
    
    </div>
  );
};

export default PatientBody;
